import { g as getResolverForContentType } from "./get-resolver-for-content-type-DlHTDn7n.js";
const abort = () => {
  return {
    beforeRequest(wretch, options, state) {
      const fetchController = wretch._config.polyfill("AbortController", false, true);
      if (!options["signal"] && fetchController) {
        options["signal"] = fetchController.signal;
      }
      const timeout = {
        ref: null,
        clear() {
          if (timeout.ref) {
            clearTimeout(timeout.ref);
            timeout.ref = null;
          }
        }
      };
      state.abort = {
        timeout,
        fetchController
      };
      return wretch;
    },
    wretch: {
      signal(controller) {
        return { ...this, _options: { ...this._options, signal: controller.signal } };
      }
    },
    resolver: {
      setTimeout(time, controller = this._sharedState.abort.fetchController) {
        const { timeout } = this._sharedState.abort;
        timeout.clear();
        timeout.ref = setTimeout(() => controller.abort(), time);
        return this;
      },
      controller() {
        return [this._sharedState.abort.fetchController, this];
      },
      onAbort(cb) {
        return this.error("AbortError", cb);
      }
    }
  };
};
const abort$1 = abort;
function utf8ToBase64(input) {
  const utf8Bytes = new TextEncoder().encode(input);
  return btoa(String.fromCharCode(...utf8Bytes));
}
const makeBasicAuthMiddleware = (config) => (next) => (url, opts) => {
  const _URL = config.polyfill("URL");
  const parsedUrl = _URL.canParse(url) ? new _URL(url) : null;
  if ((parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.username) || (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.password)) {
    const basicAuthBase64 = utf8ToBase64(`${decodeURIComponent(parsedUrl.username)}:${decodeURIComponent(parsedUrl.password)}`);
    opts.headers = {
      ...opts.headers,
      Authorization: `Basic ${basicAuthBase64}`
    };
    parsedUrl.username = "";
    parsedUrl.password = "";
    url = parsedUrl.toString();
  }
  return next(url, opts);
};
const basicAuth = {
  beforeRequest(wretch) {
    return wretch.middlewares([makeBasicAuthMiddleware(wretch._config)]);
  },
  wretch: {
    basicAuth(username, password) {
      const basicAuthBase64 = utf8ToBase64(`${username}:${password}`);
      return this.auth(`Basic ${basicAuthBase64}`);
    }
  }
};
const basicAuth$1 = basicAuth;
function convertFormData(formObject, recursive = false, config, formData2 = config.polyfill("FormData", true, true), ancestors = []) {
  Object.entries(formObject).forEach(([key, value]) => {
    let formKey = ancestors.reduce((acc, ancestor) => acc ? `${acc}[${ancestor}]` : ancestor, null);
    formKey = formKey ? `${formKey}[${key}]` : key;
    if (value instanceof Array || globalThis.FileList && value instanceof FileList) {
      for (const item of value)
        formData2.append(formKey, item);
    } else if (recursive && typeof value === "object" && (!(recursive instanceof Array) || !recursive.includes(key))) {
      if (value !== null) {
        convertFormData(value, recursive, config, formData2, [...ancestors, key]);
      }
    } else {
      formData2.append(formKey, value);
    }
  });
  return formData2;
}
const formData = {
  wretch: {
    formData(formObject, recursive = false) {
      return this.body(convertFormData(formObject, recursive, this._config));
    }
  }
};
const formData$1 = formData;
function encodeQueryValue(key, value) {
  return encodeURIComponent(key) + "=" + encodeURIComponent(typeof value === "object" ? JSON.stringify(value) : "" + value);
}
function convertFormUrl(formObject) {
  return Object.keys(formObject).map((key) => {
    const value = formObject[key];
    if (value instanceof Array) {
      return value.map((v) => encodeQueryValue(key, v)).join("&");
    }
    return encodeQueryValue(key, value);
  }).join("&");
}
const formUrl = {
  wretch: {
    formUrl(input) {
      return this.body(typeof input === "string" ? input : convertFormUrl(input)).content("application/x-www-form-urlencoded");
    }
  }
};
const formUrl$1 = formUrl;
const perfs = () => {
  const callbacks = /* @__PURE__ */ new Map();
  let observer = null;
  const onMatch = (entries, name, callback, performance) => {
    if (!entries.getEntriesByName)
      return false;
    const matches2 = entries.getEntriesByName(name);
    if (matches2 && matches2.length > 0) {
      callback(matches2.reverse()[0]);
      if (performance.clearMeasures)
        performance.clearMeasures(name);
      callbacks.delete(name);
      if (callbacks.size < 1) {
        observer.disconnect();
        if (performance.clearResourceTimings) {
          performance.clearResourceTimings();
        }
      }
      return true;
    }
    return false;
  };
  const initObserver = (performance, performanceObserver) => {
    if (!observer && performance && performanceObserver) {
      observer = new performanceObserver((entries) => {
        callbacks.forEach((callback, name) => {
          onMatch(entries, name, callback, performance);
        });
      });
      if (performance.clearResourceTimings) {
        performance.clearResourceTimings();
      }
    }
    return observer;
  };
  const monitor = (name, callback, config) => {
    if (!name || !callback)
      return;
    const performance = config.polyfill("performance", false);
    const performanceObserver = config.polyfill("PerformanceObserver", false);
    if (!initObserver(performance, performanceObserver))
      return;
    if (!onMatch(performance, name, callback, performance)) {
      if (callbacks.size < 1)
        observer.observe({ entryTypes: ["resource", "measure"] });
      callbacks.set(name, callback);
    }
  };
  return {
    resolver: {
      perfs(cb) {
        this._fetchReq.then((res) => monitor(this._wretchReq._url, cb, this._wretchReq._config)).catch(() => {
        });
        return this;
      }
    }
  };
};
const perfs$1 = perfs;
function stringify(value) {
  return typeof value !== "undefined" ? value : "";
}
const appendQueryParams = (url, qp, replace2, omitUndefinedOrNullValues, config) => {
  let queryString2;
  if (typeof qp === "string") {
    queryString2 = qp;
  } else {
    const usp = config.polyfill("URLSearchParams", true, true);
    for (const key in qp) {
      const value = qp[key];
      if (omitUndefinedOrNullValues && (value === null || value === void 0))
        continue;
      if (qp[key] instanceof Array) {
        for (const val of value)
          usp.append(key, stringify(val));
      } else {
        usp.append(key, stringify(value));
      }
    }
    queryString2 = usp.toString();
  }
  const split = url.split("?");
  if (!queryString2)
    return replace2 ? split[0] : url;
  if (replace2 || split.length < 2)
    return split[0] + "?" + queryString2;
  return url + "&" + queryString2;
};
const queryString = {
  wretch: {
    query(qp, replace2 = false, omitUndefinedOrNullValues = false) {
      return { ...this, _url: appendQueryParams(this._url, qp, replace2, omitUndefinedOrNullValues, this._config) };
    }
  }
};
const queryString$1 = queryString;
const progress = () => {
  function transformMiddleware(state) {
    return (next) => (url, opts) => {
      let loaded = 0;
      let total = 0;
      return next(url, opts).then((response) => {
        try {
          const contentLength = response.headers.get("content-length");
          total = contentLength ? +contentLength : null;
          const transform2 = new TransformStream({
            transform(chunk, controller) {
              loaded += chunk.length;
              if (total < loaded) {
                total = loaded;
              }
              if (state.progress) {
                state.progress(loaded, total);
              }
              controller.enqueue(chunk);
            }
          });
          return new Response(response.body.pipeThrough(transform2), response);
        } catch (e) {
          return response;
        }
      });
    };
  }
  return {
    beforeRequest(wretch, _, state) {
      return wretch.middlewares([transformMiddleware(state)]);
    },
    resolver: {
      progress(onProgress) {
        this._sharedState.progress = onProgress;
        return this;
      }
    }
  };
};
const progress$1 = progress;
const caller = {
  wretch: {
    caller(callerName) {
      return this.headers({
        "X-Caller": callerName
      });
    }
  }
};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var mapObj = { exports: {} };
const isObject$2 = (value) => typeof value === "object" && value !== null;
const mapObjectSkip$1 = Symbol("skip");
const isObjectCustom$1 = (value) => isObject$2(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObject$1 = (object, mapper, options, isSeen = /* @__PURE__ */ new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  const { target } = options;
  delete options.target;
  const mapArray = (array) => array.map((element) => isObjectCustom$1(element) ? mapObject$1(element, mapper, options, isSeen) : element);
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (const [key, value] of Object.entries(object)) {
    const mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip$1) {
      continue;
    }
    let [newKey, newValue, { shouldRecurse = true } = {}] = mapResult;
    if (newKey === "__proto__") {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom$1(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObject$1(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
mapObj.exports = (object, mapper, options) => {
  if (!isObject$2(object)) {
    throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
  }
  return mapObject$1(object, mapper, options);
};
mapObj.exports.mapObjectSkip = mapObjectSkip$1;
var mapObjExports = mapObj.exports;
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function lowerCase(str) {
  return str.toLowerCase();
}
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform2 = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
  var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
  var start = 0;
  var end = result.length;
  while (result.charAt(start) === "\0")
    start++;
  while (result.charAt(end - 1) === "\0")
    end--;
  return result.slice(start, end).split("\0").map(transform2).join(delimiter);
}
function replace(input, re, value) {
  if (re instanceof RegExp)
    return input.replace(re, value);
  return re.reduce(function(input2, re2) {
    return input2.replace(re2, value);
  }, input);
}
function dotCase(input, options) {
  if (options === void 0) {
    options = {};
  }
  return noCase(input, __assign({ delimiter: "." }, options));
}
function snakeCase$1(input, options) {
  if (options === void 0) {
    options = {};
  }
  return dotCase(input, __assign({ delimiter: "_" }, options));
}
const dist_es2015 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  snakeCase: snakeCase$1
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(dist_es2015);
const map = mapObjExports;
const { snakeCase } = require$$1;
const PlainObjectConstructor = {}.constructor;
var snakecaseKeys = function(obj, options) {
  if (Array.isArray(obj)) {
    if (obj.some((item) => item.constructor !== PlainObjectConstructor)) {
      throw new Error("obj must be array of plain objects");
    }
  } else {
    if (obj.constructor !== PlainObjectConstructor) {
      throw new Error("obj must be an plain object");
    }
  }
  options = Object.assign({ deep: true, exclude: [], parsingOptions: {} }, options);
  return map(obj, function(key, val) {
    return [
      matches(options.exclude, key) ? key : snakeCase(key, options.parsingOptions),
      val,
      mapperOptions(key, val, options)
    ];
  }, options);
};
function matches(patterns, value) {
  return patterns.some(function(pattern) {
    return typeof pattern === "string" ? pattern === value : pattern.test(value);
  });
}
function mapperOptions(key, val, options) {
  return options.shouldRecurse ? { shouldRecurse: options.shouldRecurse(key, val) } : void 0;
}
const snakeCaseKeys = /* @__PURE__ */ getDefaultExportFromCjs(snakecaseKeys);
const snakeCaseBody = (defaultOptions) => {
  return {
    wretch: {
      snakeCaseBody(payload, options) {
        const snakeCasedPayload = snakeCaseKeys(payload, {
          ...defaultOptions,
          ...options
        });
        return this.body(JSON.stringify(snakeCasedPayload)).content(
          "application/json"
        );
      }
    }
  };
};
const isObject$1 = (value) => typeof value === "object" && value !== null;
const isObjectCustom = (value) => isObject$1(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const mapObjectSkip = Symbol("mapObjectSkip");
const _mapObject = (object, mapper, options, isSeen = /* @__PURE__ */ new WeakMap()) => {
  options = {
    deep: false,
    target: {},
    ...options
  };
  if (isSeen.has(object)) {
    return isSeen.get(object);
  }
  isSeen.set(object, options.target);
  const { target } = options;
  delete options.target;
  const mapArray = (array) => array.map((element) => isObjectCustom(element) ? _mapObject(element, mapper, options, isSeen) : element);
  if (Array.isArray(object)) {
    return mapArray(object);
  }
  for (const [key, value] of Object.entries(object)) {
    const mapResult = mapper(key, value, object);
    if (mapResult === mapObjectSkip) {
      continue;
    }
    let [newKey, newValue, { shouldRecurse = true } = {}] = mapResult;
    if (newKey === "__proto__") {
      continue;
    }
    if (options.deep && shouldRecurse && isObjectCustom(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : _mapObject(newValue, mapper, options, isSeen);
    }
    target[newKey] = newValue;
  }
  return target;
};
function mapObject(object, mapper, options) {
  if (!isObject$1(object)) {
    throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
  }
  return _mapObject(object, mapper, options);
}
const UPPERCASE = /[\p{Lu}]/u;
const LOWERCASE = /[\p{Ll}]/u;
const LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const SEPARATORS = /[_.\- ]+/;
const LEADING_SEPARATORS = new RegExp("^" + SEPARATORS.source);
const SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, "gu");
const NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + IDENTIFIER.source, "gu");
const preserveCamelCase = (string, toLowerCase, toUpperCase, preserveConsecutiveUppercase2) => {
  let isLastCharLower = false;
  let isLastCharUpper = false;
  let isLastLastCharUpper = false;
  let isLastLastCharPreserved = false;
  for (let index = 0; index < string.length; index++) {
    const character = string[index];
    isLastLastCharPreserved = index > 2 ? string[index - 3] === "-" : true;
    if (isLastCharLower && UPPERCASE.test(character)) {
      string = string.slice(0, index) + "-" + string.slice(index);
      isLastCharLower = false;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = true;
      index++;
    } else if (isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character) && (!isLastLastCharPreserved || preserveConsecutiveUppercase2)) {
      string = string.slice(0, index - 1) + "-" + string.slice(index - 1);
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = false;
      isLastCharLower = true;
    } else {
      isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
      isLastLastCharUpper = isLastCharUpper;
      isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
    }
  }
  return string;
};
const preserveConsecutiveUppercase = (input, toLowerCase) => {
  LEADING_CAPITAL.lastIndex = 0;
  return input.replaceAll(LEADING_CAPITAL, (match) => toLowerCase(match));
};
const postProcess = (input, toUpperCase) => {
  SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
  NUMBERS_AND_IDENTIFIER.lastIndex = 0;
  return input.replaceAll(NUMBERS_AND_IDENTIFIER, (match, pattern, offset) => ["_", "-"].includes(input.charAt(offset + match.length)) ? match : toUpperCase(match)).replaceAll(SEPARATORS_AND_IDENTIFIER, (_, identifier) => toUpperCase(identifier));
};
function camelCase(input, options) {
  if (!(typeof input === "string" || Array.isArray(input))) {
    throw new TypeError("Expected the input to be `string | string[]`");
  }
  options = {
    pascalCase: false,
    preserveConsecutiveUppercase: false,
    ...options
  };
  if (Array.isArray(input)) {
    input = input.map((x) => x.trim()).filter((x) => x.length).join("-");
  } else {
    input = input.trim();
  }
  if (input.length === 0) {
    return "";
  }
  const toLowerCase = options.locale === false ? (string) => string.toLowerCase() : (string) => string.toLocaleLowerCase(options.locale);
  const toUpperCase = options.locale === false ? (string) => string.toUpperCase() : (string) => string.toLocaleUpperCase(options.locale);
  if (input.length === 1) {
    if (SEPARATORS.test(input)) {
      return "";
    }
    return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
  }
  const hasUpperCase = input !== toLowerCase(input);
  if (hasUpperCase) {
    input = preserveCamelCase(input, toLowerCase, toUpperCase, options.preserveConsecutiveUppercase);
  }
  input = input.replace(LEADING_SEPARATORS, "");
  input = options.preserveConsecutiveUppercase ? preserveConsecutiveUppercase(input, toLowerCase) : toLowerCase(input);
  if (options.pascalCase) {
    input = toUpperCase(input.charAt(0)) + input.slice(1);
  }
  return postProcess(input, toUpperCase);
}
class QuickLRU extends Map {
  constructor(options = {}) {
    super();
    if (!(options.maxSize && options.maxSize > 0)) {
      throw new TypeError("`maxSize` must be a number greater than 0");
    }
    if (typeof options.maxAge === "number" && options.maxAge === 0) {
      throw new TypeError("`maxAge` must be a number greater than 0");
    }
    this.maxSize = options.maxSize;
    this.maxAge = options.maxAge || Number.POSITIVE_INFINITY;
    this.onEviction = options.onEviction;
    this.cache = /* @__PURE__ */ new Map();
    this.oldCache = /* @__PURE__ */ new Map();
    this._size = 0;
  }
  // TODO: Use private class methods when targeting Node.js 16.
  _emitEvictions(cache2) {
    if (typeof this.onEviction !== "function") {
      return;
    }
    for (const [key, item] of cache2) {
      this.onEviction(key, item.value);
    }
  }
  _deleteIfExpired(key, item) {
    if (typeof item.expiry === "number" && item.expiry <= Date.now()) {
      if (typeof this.onEviction === "function") {
        this.onEviction(key, item.value);
      }
      return this.delete(key);
    }
    return false;
  }
  _getOrDeleteIfExpired(key, item) {
    const deleted = this._deleteIfExpired(key, item);
    if (deleted === false) {
      return item.value;
    }
  }
  _getItemValue(key, item) {
    return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
  }
  _peek(key, cache2) {
    const item = cache2.get(key);
    return this._getItemValue(key, item);
  }
  _set(key, value) {
    this.cache.set(key, value);
    this._size++;
    if (this._size >= this.maxSize) {
      this._size = 0;
      this._emitEvictions(this.oldCache);
      this.oldCache = this.cache;
      this.cache = /* @__PURE__ */ new Map();
    }
  }
  _moveToRecent(key, item) {
    this.oldCache.delete(key);
    this._set(key, item);
  }
  *_entriesAscending() {
    for (const item of this.oldCache) {
      const [key, value] = item;
      if (!this.cache.has(key)) {
        const deleted = this._deleteIfExpired(key, value);
        if (deleted === false) {
          yield item;
        }
      }
    }
    for (const item of this.cache) {
      const [key, value] = item;
      const deleted = this._deleteIfExpired(key, value);
      if (deleted === false) {
        yield item;
      }
    }
  }
  get(key) {
    if (this.cache.has(key)) {
      const item = this.cache.get(key);
      return this._getItemValue(key, item);
    }
    if (this.oldCache.has(key)) {
      const item = this.oldCache.get(key);
      if (this._deleteIfExpired(key, item) === false) {
        this._moveToRecent(key, item);
        return item.value;
      }
    }
  }
  set(key, value, { maxAge = this.maxAge } = {}) {
    const expiry = typeof maxAge === "number" && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : void 0;
    if (this.cache.has(key)) {
      this.cache.set(key, {
        value,
        expiry
      });
    } else {
      this._set(key, { value, expiry });
    }
    return this;
  }
  has(key) {
    if (this.cache.has(key)) {
      return !this._deleteIfExpired(key, this.cache.get(key));
    }
    if (this.oldCache.has(key)) {
      return !this._deleteIfExpired(key, this.oldCache.get(key));
    }
    return false;
  }
  peek(key) {
    if (this.cache.has(key)) {
      return this._peek(key, this.cache);
    }
    if (this.oldCache.has(key)) {
      return this._peek(key, this.oldCache);
    }
  }
  delete(key) {
    const deleted = this.cache.delete(key);
    if (deleted) {
      this._size--;
    }
    return this.oldCache.delete(key) || deleted;
  }
  clear() {
    this.cache.clear();
    this.oldCache.clear();
    this._size = 0;
  }
  resize(newSize) {
    if (!(newSize && newSize > 0)) {
      throw new TypeError("`maxSize` must be a number greater than 0");
    }
    const items = [...this._entriesAscending()];
    const removeCount = items.length - newSize;
    if (removeCount < 0) {
      this.cache = new Map(items);
      this.oldCache = /* @__PURE__ */ new Map();
      this._size = items.length;
    } else {
      if (removeCount > 0) {
        this._emitEvictions(items.slice(0, removeCount));
      }
      this.oldCache = new Map(items.slice(removeCount));
      this.cache = /* @__PURE__ */ new Map();
      this._size = 0;
    }
    this.maxSize = newSize;
  }
  *keys() {
    for (const [key] of this) {
      yield key;
    }
  }
  *values() {
    for (const [, value] of this) {
      yield value;
    }
  }
  *[Symbol.iterator]() {
    for (const item of this.cache) {
      const [key, value] = item;
      const deleted = this._deleteIfExpired(key, value);
      if (deleted === false) {
        yield [key, value.value];
      }
    }
    for (const item of this.oldCache) {
      const [key, value] = item;
      if (!this.cache.has(key)) {
        const deleted = this._deleteIfExpired(key, value);
        if (deleted === false) {
          yield [key, value.value];
        }
      }
    }
  }
  *entriesDescending() {
    let items = [...this.cache];
    for (let i = items.length - 1; i >= 0; --i) {
      const item = items[i];
      const [key, value] = item;
      const deleted = this._deleteIfExpired(key, value);
      if (deleted === false) {
        yield [key, value.value];
      }
    }
    items = [...this.oldCache];
    for (let i = items.length - 1; i >= 0; --i) {
      const item = items[i];
      const [key, value] = item;
      if (!this.cache.has(key)) {
        const deleted = this._deleteIfExpired(key, value);
        if (deleted === false) {
          yield [key, value.value];
        }
      }
    }
  }
  *entriesAscending() {
    for (const [key, value] of this._entriesAscending()) {
      yield [key, value.value];
    }
  }
  get size() {
    if (!this._size) {
      return this.oldCache.size;
    }
    let oldCacheSize = 0;
    for (const key of this.oldCache.keys()) {
      if (!this.cache.has(key)) {
        oldCacheSize++;
      }
    }
    return Math.min(this._size + oldCacheSize, this.maxSize);
  }
  entries() {
    return this.entriesAscending();
  }
  forEach(callbackFunction, thisArgument = this) {
    for (const [key, value] of this.entriesAscending()) {
      callbackFunction.call(thisArgument, value, key, this);
    }
  }
  get [Symbol.toStringTag]() {
    return JSON.stringify([...this.entriesAscending()]);
  }
}
const has = (array, key) => array.some((element) => {
  if (typeof element === "string") {
    return element === key;
  }
  element.lastIndex = 0;
  return element.test(key);
});
const cache = new QuickLRU({ maxSize: 1e5 });
const isObject = (value) => typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const transform = (input, options = {}) => {
  if (!isObject(input)) {
    return input;
  }
  const {
    exclude,
    pascalCase = false,
    stopPaths,
    deep = false,
    preserveConsecutiveUppercase: preserveConsecutiveUppercase2 = false
  } = options;
  const stopPathsSet = new Set(stopPaths);
  const makeMapper = (parentPath) => (key, value) => {
    if (deep && isObject(value)) {
      const path = parentPath === void 0 ? key : `${parentPath}.${key}`;
      if (!stopPathsSet.has(path)) {
        value = mapObject(value, makeMapper(path));
      }
    }
    if (!(exclude && has(exclude, key))) {
      const cacheKey = pascalCase ? `${key}_` : key;
      if (cache.has(cacheKey)) {
        key = cache.get(cacheKey);
      } else {
        const returnValue = camelCase(key, { pascalCase, locale: false, preserveConsecutiveUppercase: preserveConsecutiveUppercase2 });
        if (key.length < 100) {
          cache.set(cacheKey, returnValue);
        }
        key = returnValue;
      }
    }
    return [key, value];
  };
  return mapObject(input, makeMapper(void 0));
};
function camelcaseKeys(input, options) {
  if (Array.isArray(input)) {
    return Object.keys(input).map((key) => transform(input[key], options));
  }
  return transform(input, options);
}
const validAddonDefaultOptions = {
  preprocess: (val) => {
    return camelcaseKeys(val, {
      deep: true,
      preserveConsecutiveUppercase: true
    });
  }
};
const valid = (defaultOptions = validAddonDefaultOptions) => {
  return {
    resolver: {
      async valid(schema, options) {
        const finalOptions = {
          ...defaultOptions,
          ...options
        };
        const preprocess = finalOptions.preprocess || ((val) => val);
        const getResolver = async () => {
          const response = await this._fetchReq;
          const contentType = response.headers.get("content-type");
          return getResolverForContentType(contentType);
        };
        this._wretchReq._options.valid = {
          preprocess,
          schema
        };
        const resolver = await getResolver();
        return this[resolver](
          (data) => schema.parse(preprocess(data))
        );
      }
    }
  };
};
export {
  abort$1 as abortAddon,
  basicAuth$1 as basicAuthAddon,
  caller,
  formData$1 as formDataAddon,
  formUrl$1 as formUrlAddon,
  perfs$1 as perfsAddon,
  progress$1 as progressAddon,
  queryString$1 as queryStringAddon,
  snakeCaseBody,
  valid,
  validAddonDefaultOptions
};
//# sourceMappingURL=addons.js.map
